// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalBody_wrapper__M__WX","body":"ModalBody_body___Z3dc","dark":"ModalBody_dark__nVWYX","hasBottomScrollIndicator":"ModalBody_hasBottomScrollIndicator__0e5D9"};